import { get } from 'lodash'

export const headers = (intl = {}) => [
  intl.formatMessage({
    id: 'table.first_name'
  }),
  intl.formatMessage({
    id: 'table.last_name'
  }),
  intl.formatMessage({
    id: 'table.id'
  }),
  intl.formatMessage({
    id: 'table.award_unit'
  }),
  intl.formatMessage({
    id: 'table.id'
  }),
  intl.formatMessage({
    id: 'table.award_level'
  }),
  intl.formatMessage({
    id: 'table.status'
  }),
  intl.formatMessage({
    id: 'table.physical_activity'
  }),
  intl.formatMessage({
    id: 'table.physical_activity'
  }),
  intl.formatMessage({
    id: 'table.physical_activity'
  }),
  intl.formatMessage({
    id: 'table.skills_activity'
  }),
  intl.formatMessage({
    id: 'table.skills_activity'
  }),
  intl.formatMessage({
    id: 'table.skills_activity'
  }),
  intl.formatMessage({
    id: 'table.service_activity'
  }),
  intl.formatMessage({
    id: 'table.service_activity'
  }),
  intl.formatMessage({
    id: 'table.service_activity'
  }),
  intl.formatMessage({
    id: 'table.aj_practice'
  }),
  intl.formatMessage({
    id: 'aj.qualifying_journey'
  }),
  intl.formatMessage({
    id: 'table.rp'
  })
]

export const line = (data = []) =>
  data.map(item => {
    return {
      line: [
        `${get(item, 'participant.firstName')}`,
        `${get(item, 'participant.lastName')}`,
        `${get(item, 'participant.globalId')}`,
        `${get(item, 'organization.name')}`,
        `${get(item, 'organization.globalId')}`,
        `${get(item, 'award.level.type')}`,
        `${get(item, 'award.state.value') || get(item, 'award.state.type')}`,
        `${get(item, 'progress.act.physicalRecreation.lastAction.value') || get(item, 'progress.act.physicalRecreation.lastAction.type')}`,
        `${get(item, 'progress.act.physicalRecreation.completedPercentage') || 0}%`,
        `${get(item, 'progress.act.physicalRecreation.completedHours') || 0} hours`,
        `${get(item, 'progress.act.skill.lastAction.value') || get(item, 'progress.act.skill.lastAction.type')}`,
        `${get(item, 'progress.act.skill.completedPercentage') || 0}%`,
        `${get(item, 'progress.act.skill.completedHours') || 0} hours`,
        `${get(item, 'progress.act.voluntaryService.lastAction.value') || get(item, 'progress.act.voluntaryService.lastAction.type')}`,
        `${get(item, 'progress.act.voluntaryService.completedPercentage') || 0}%`,
        `${get(item, 'progress.act.voluntaryService.completedHours') || 0} hours`,
        `${get(item, 'progress.aj.practice.lastAction.value') || get(item, 'progress.aj.practice.lastAction.type')}`,
        `${get(item, 'progress.aj.qualification.lastAction.value') || get(item, 'progress.aj.qualification.lastAction.type')}`,
        `${get(item, 'progress.rp.lastAction.value') || get(item, 'progress.rp.lastAction.type')}`,
      ]
    }
  })
